module.exports = __webpack_public_path__ + "media/images/pic/saska_building-1b75c105072bc5f10f38dc7ca89e9639.svg";